//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

const tierRange = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getTierrange(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/tierrange/get-tierrange?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getTierrangeDetail(id) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(`${config.host}/cdr-panel/tierrange/get-tierrange/${id}`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function search(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/tierrange/search?query=${encodeURIComponent(query)}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getSalesCategory() {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(
        `${config.host}/cdr-panel/mpc/get-sales-category`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getOrg() {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(`${config.host}/cdr-panel/mpc/get-org`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function update(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/tierrange/update`, obj);
      let body = await res.json();
      return body;
    } catch (err) {}
  }

  async function mpcFilter(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/mpc/mpc-filter?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
  async function tierrangeExport(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/tierrange/export`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  return {
    getTierrange,
    getTierrangeDetail,
    search,
    getSalesCategory,
    getOrg,
    mpcFilter,
    update,
    tierrangeExport,
  };
};


export default tierRange;